import useRebookEvent from '@/legacy-src/components/reservation/hooks/useRebookEvent'

import { ClientBookingRebookingNotificationUI } from './ClientBookingRebookingNotification.ui'

export const ClientBookingRebookingNotification = () => {
  const { isRebookingInProgress, originalEventData, cancelRebooking } = useRebookEvent()

  if (!isRebookingInProgress || !originalEventData) {
    return null
  }

  return <ClientBookingRebookingNotificationUI event={originalEventData} onCancel={cancelRebooking} />
}
